var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',[_c('el-row',[_c('el-col',{staticClass:"header-index"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},_vm._l((_vm.actions),function(action){return _c('el-tooltip',{key:action.title,attrs:{"content":action.title,"placement":"top"}},[_c('i',{staticClass:"clickable",class:action.icon,on:{"click":action.onClick}})])}))])],1),_vm._v(" "),_c('hr')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d89c058","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 849
// module chunks = 1